import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "components/Loader";
import UserNotification from "components/UserNotification";
import Button from "components/CustomButton";
import Scrollbar from "react-scrollbars-custom";
import classNames from "classnames";
import ClickAwayListener from "react-click-away-listener";

export default ({
  notifications,
  closeNotificationBar,
  notificationTotal,
  isLoading,
  getNextNotificationPageData,
}) => {
  const LoaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  const LoadingContainer = (
    <>
      {isLoading && (
        <h4>
          <Loader loaderStyle={LoaderStyle} width={35} height={35} />
        </h4>
      )}
      {!isLoading && (
        <h4>
          <Button onClick={getNextNotificationPageData}>Load More</Button>
        </h4>
      )}
    </>
  );

  return (
    <ClickAwayListener onClickAway={closeNotificationBar}>
      <div
        className={classNames({
          "notifications-sidebar": true,
          notificationBar: true,
          noNotificationBar: notifications.length === 0 ? true : false,
        })}
      >
        <Scrollbar style={{ display: "contents", width: "100%" }}>
          <InfiniteScroll
            style={{ overflow: "hidden" }}
            dataLength={notificationTotal ?? 0}
            next={getNextNotificationPageData}
            hasMore={notifications.length !== notificationTotal}
            loader={LoadingContainer}
            scrollableTarget="main-panel-right"
            endMessage={
              <div style={{ textAlign: "center" }}>
                {notificationTotal > 0 && (
                  <div>Yay! You have seen it invitation all</div>
                )}
              </div>
            }
          >
            <UserNotification
              notifications={notifications}
              isLoading={isLoading}
            />
          </InfiniteScroll>
        </Scrollbar>
      </div>
    </ClickAwayListener>
  );
};
